module.exports = __webpack_public_path__ + "img/charge_history@2x.d209df00.png";